<template>
    <div class="DiscountCode">
        <div class="DiscountCode-title">Mám slevový kód</div>
        <BaseAlert v-if="configuration.discount.success || configuration.discount.message" :type="configuration.discount.success ? 'success' : 'error'">
            <span v-if="configuration.discount.success">Slevový kód {{ configuration.discount.discount.code }} byl aktivován.</span>
            <span v-if="!configuration.discount.success">{{ configuration.discount.message }}</span>
        </BaseAlert>
        <template v-if="configuration.discount.success">
            <BaseButton type="submit" @click="() => configuration.removeDiscountCode()">Zrušit slevový kód</BaseButton>
        </template>
        <template v-else>
            <BaseInput type="text" label="Slevový kód" v-model="discountCode"/>
            <BaseButton type="submit" @click="() => configuration.setDiscountCode(discountCode)">Uplatnit</BaseButton>
        </template>
    </div>
</template>

<script>
import {ref} from "vue";

export default {
    name: "DiscountCode",
    props: {
        configuration: Object
    },
    setup(props) {
        const discountCode = ref(props.configuration.usedDiscountCode);
        return {
            discountCode
        };
    }
}
</script>

<style lang="scss" scoped>
.DiscountCode {

    &-title {
        font-size: var(--textLg);
        font-weight: 700;
        margin: .5em 0 1em;
        color: var(--colorBrandDark);
    }

    .BaseButton {
        margin-top: 1rem;
    }

    .BaseAlert--success {
        margin-bottom: 0;
    }
}
</style>